import PropTypes from 'prop-types';
import { createContext, useContext, useMemo, useState } from 'react';

const WorkspaceSyncStatusContext = createContext(null);

export function WorkspaceSyncStatusProvider({ children }) {
  const [activeSyncCount, setActiveSyncCount] = useState(0);
  const [status, setStatus] = useState('idle');

  const value = useMemo(
    () => ({
      status,
      isSyncing: activeSyncCount > 0 || status === 'syncing',
      startSync() {
        setActiveSyncCount((current) => current + 1);
        setStatus('syncing');
      },
      finishSync() {
        setActiveSyncCount((current) => {
          const next = Math.max(0, current - 1);
          if (next === 0) {
            setStatus('idle');
          }
          return next;
        });
      },
      failSync() {
        setActiveSyncCount(0);
        setStatus('error');
      },
      clearSyncState() {
        setActiveSyncCount(0);
        setStatus('idle');
      }
    }),
    [activeSyncCount, status]
  );

  return <WorkspaceSyncStatusContext.Provider value={value}>{children}</WorkspaceSyncStatusContext.Provider>;
}

WorkspaceSyncStatusProvider.propTypes = {
  children: PropTypes.node
};

export function useWorkspaceSyncStatus() {
  const context = useContext(WorkspaceSyncStatusContext);

  if (!context) {
    throw new Error('useWorkspaceSyncStatus must be used within a WorkspaceSyncStatusProvider');
  }

  return context;
}
